
<template>
  <div class="pos-fnb-container">
    <div class="ticket-wrapper">
      <div class="ticket-section">
        <table style="margin: 0 auto">
          <tbody>
            <tr>
              <td>
                <div>Binary Numbers #4, 2nd Floor,</div>
                <div>Citi Mall, Oshiwara Link Road,</div>
                <div>Andheri West, Mumbai,</div>
                <div>Maharashtra 400053</div>
                <div>Served by: 2 13/10/2019 21:37:52</div>
                <div>Order ID: 1/A-104725</div>
              </td>
            </tr>
          </tbody>
        </table>

        <table style="margin: 0 auto; width: 100%;s">
          <tbody>
            <tr>
              <td style="text-align: left;">
                <span style="border-bottom: 1px dashed; padding-bottom: 10px;">Item</span>
              </td>
              <td>
                <span style="border-bottom: 1px dashed; padding-bottom: 10px;">Qty</span>
              </td>
              <td>
                <span style="border-bottom: 1px dashed; padding-bottom: 10px;">Price</span>
              </td>
            </tr>

            <tr>
              <td style="padding-top: 15px; text-align: left;">PaneerTikka Salad</td>
              <td style="padding-top: 15px;">1</td>
              <td style="padding-top: 15px;">220.00</td>
            </tr>

            <tr>
              <td style="text-align: left;">ChknSeekhMasala WrpFlx</td>
              <td>2</td>
              <td>480.00</td>
            </tr>

            <tr>
              <td style="text-align: left;">Chicken Tandoori 30cm</td>
              <td>2</td>
              <td>700.00</td>
            </tr>

            <tr>
              <td style="text-align: left;">SOTD6inMex Bean & Tuna</td>
              <td>1</td>
              <td>140.00</td>
            </tr>

            <tr>
              <td style="text-align: left;">-Mexican Bean Patty 15cm</td>
              <td>1</td>
              <td></td>
            </tr>
          </tbody>
        </table>

        <table style="margin: 0 auto; width: 100%; margin-top: 8px;">
          <tbody>
            <tr>
              <td style="width: 50%; text-align: left;">Sub Total</td>
              <td style="width: 50%; text-align: right; padding-right: 4px;">1,466.66</td>
            </tr>

            <tr>
              <td style="width: 50%; text-align: left;">S.GST</td>
              <td style="width: 50%; text-align: right; padding-right: 4px;">36.67</td>
            </tr>

            <tr>
              <td style="width: 50%; text-align: left;">C.GST</td>
              <td style="width: 50%; text-align: right; padding-right: 4px;">36.67</td>
            </tr>

            <tr>
              <td style="width: 50%; text-align: left; font-weight: bold;">Total</td>
              <td
                style="width: 50%; text-align: right; padding-right: 4px; font-weight: bold;"
              >1,540.00</td>
            </tr>

            <tr>
              <td style="width: 50%; text-align: left;">Cash</td>
              <td style="width: 50%; text-align: right; padding-right: 4px;">1,540.00</td>
            </tr>

            <tr>
              <td style="width: 50%; text-align: left;">Change</td>
              <td style="width: 50%; text-align: right; padding-right: 4px;">0.00</td>
            </tr>
          </tbody>
        </table>

        <table style="margin-top: 8px;">
          <tbody>
            <tr>
              <td style="text-align: left;">
                <div style="padding-bottom: 5px;">GSTN : 27AAKFA5469R1ZK</div>
                <div>We love to LISTEN!! Please let us know how we did today by taking our 1 minute survey at binarynumbers.io</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    // ...mapState(["fnbSearch"]),
    ...mapGetters([]),
    ...mapState({})
  },
  mounted() {},
  methods: {
    // saif
    ...mapActions([])
    // Saif
  }
};
</script>
<style scoped>
.ticket-section {
  text-align: center;
  height: calc(100% - 52.913385826px);
  padding: 8px;
}

.ticket-wrapper {
  width: 302.36220472px;
  height: 100%;
  border: 1px solid #000000;
}

td {
  padding: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/PosFnbContainer/PosFnBFinalPrintTicket.vue